import React from 'react'
import NumberFormat from 'react-number-format'

export default function NumeroDecimal({ children, decimalScale = 2 }) {
  return (
    <NumberFormat
      value={children}
      displayType={'text'}
      isNumericString={true}
      thousandSeparator="."
      decimalSeparator=","
      decimalScale={decimalScale}
      fixedDecimalScale={true}
    />
  )
}
